import { apiCall } from "./common/base.service"
import config from "../config/application"
import permission from "./permissions.service"
import dictionary from "../config/dictionary"

class MonitorService {
  getSupplier = async data => {
    const url = `${config.data.providers.monitor.url}supplier`
    return apiCall("put", url, data)
  }
  getUserData = data => {
    const url = `${config.data.providers.monitor.url}user`
    return apiCall("put", url, data)
  }

  getUserActive = data => {
    const url = `${config.data.providers.monitor.url}user/active`
    return apiCall("put", url, data)
  }

  getOrderCount=filter=>{
    const url = `${config.data.providers.monitor.url}orders/state/count`
    return apiCall("put", url, filter)
  }
  getBillCount=filter=>{
    const url = `${config.data.providers.monitor.url}bill/state/count`
    return apiCall("put", url, filter)
  }
  exportOrder = async data => {
    const url = `${config.data.providers.monitor.url}orders/export`
    const validPermission = await monitor.getPermissions(
      data.createdBy,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("put", url, data)
  }

  getOrder = async data => {
    const url = `${config.data.providers.monitor.url}orders/details`
    const validPermission = await monitor.getPermissions(
      data.createdBy,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("put", url, data)
  }

  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_MONITOR,
      username,
      process.env.REACT_APP_SYSTEM_CODE, action);

  }
}

const monitor = new MonitorService()
export default monitor
